module.exports = __webpack_public_path__ + "img/org2.cded4c0f.png";